
import React from 'react';
import { AlertTriangle } from 'lucide-react';

const NoAnalyticsData = () => {
  return (
    <div className="h-60 flex flex-col items-center justify-center p-6 bg-gray-50 rounded-lg border border-gray-200">
      <AlertTriangle className="h-8 w-8 text-gray-400 mb-2" />
      <p className="text-gray-500 font-medium">No analytics data available.</p>
      <p className="text-gray-400 text-sm mt-1 text-center">
        Complete a few game sessions to see performance and usage data.
      </p>
    </div>
  );
};

export default NoAnalyticsData;
